import React from 'react';

import { useTitle } from 'src/hooks/useTitle';

import { ServiceMetrics } from '../ServiceMetrics';

export const AmuMetrics: React.FC = () => {
    useTitle('AMU Metrics');

    return (
        <ServiceMetrics
            serviceName="AMU"
            title="AMU Licensing KPI's"
            description="View and analyze detailed licensing KPI's - STEMP level data with advanced filtering and export capabilities"
            serviceId={1}
        />
    );
};
